module.exports = __webpack_public_path__ + "img/haslach_logo.4a1fd797.png";